import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { ApplicationConfig } from '../config/application.config';
import { LanguageVersion } from '../../shared/model/local/config/language-version';
import { ApplicationSelectors } from '../../shared/store/application/application.selectors';
import { Constant } from '../../shared/common/constant';

@Injectable()
export class AppLanguageInterceptor implements HttpInterceptor {
  constructor(private store: Store) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.method && request.url?.indexOf(ApplicationConfig.apiUrl) > -1) {
      const currentLanguage: LanguageVersion = this.store.selectSnapshot(
        ApplicationSelectors.language
      );

      const appLanguageRequest: HttpRequest<any> = request.clone({
        setHeaders: {
          [Constant.HTTP_APP_LANGUAGE_HEADER]: currentLanguage,
        },
      });

      return next.handle(appLanguageRequest);
    } else {
      return next.handle(request);
    }
  }
}
